import MuiTab from "@mui/material/Tab";

export default function Tab(props) {
  return <MuiTab {...props} />;
}
